import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router";
import { jobApprovals, jobApprovalKeys } from "@/lib/job-approvals";

export function JobApprovalsPage() {
  const { data = [], isLoading } = useQuery({
    queryKey: jobApprovalKeys.cross({ status: "pending" }),
    queryFn: () => jobApprovals.cross({ status: "pending" }),
  });
  return (
    <main className="p-6 max-w-5xl">
      <h1 className="text-2xl font-bold mb-4">Pending Job Approvals</h1>
      {isLoading ? (
        <p>Loading…</p>
      ) : data.length === 0 ? (
        <p>No pending approvals.</p>
      ) : (
        <table className="w-full text-sm">
          <thead>
            <tr>
              <th>Job</th>
              <th>Client</th>
              <th>Type</th>
              <th>Requested by</th>
              <th>Age</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {data.map((r) => (
              <tr key={r.jobApprovalId}>
                <td>
                  <Link to={`/jobs/${r.jobId}`}>{r.jobReferenceNo}</Link>
                </td>
                <td>{r.clientName ?? "—"}</td>
                <td>{r.approvalTypeLabel}</td>
                <td>{r.requestedByUserName}</td>
                <td>{r.ageDays}d</td>
                <td>{r.currentJobStatusCode}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  );
}
